/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { useContext, useEffect } from 'react';
import { Col, Result, Row } from 'antd';
import singleDeviceStyles from '../../styles.module.css';
import { DeviceDetailsContext } from '../../index';
import DeviceOperations from '../../components/DeviceOperations';
import DeviceOperationLog from './Components/DeviceOperationLog';
import Authorized from '../../../../../../components/Authorized';
import HtmlComments from '../../../../../../components/ReactHtmlComments/HtmlComments';
import { useTranslation } from 'react-i18next';

const Log = () => {
  const deviceDetails = useContext(DeviceDetailsContext);
  const { t } = useTranslation();
  useEffect(() => {
    // Update the current route's key
    deviceDetails.setCurrentRoute('log');
  }, []);
  return (
    <Row>
      <Col md={19}>
        <div className={singleDeviceStyles.container}>
          <HtmlComments
            permission={
              '/permission/admin/device-mgt/device-type/features/view'
            }
          />
          <Authorized
            scope={['perm:device-types:features']}
            yes={
              <DeviceOperationLog
                deviceIdentifier={deviceDetails.deviceIdentifier}
                deviceType={deviceDetails.deviceType}
                owner={deviceDetails.device.enrolmentInfo.owner}
              />
            }
            no={
              <Result
                status="403"
                title={t('noPerm_accessPageTitle')}
                subTitle={t('noPerm_contactSysAdmin')}
              />
            }
          />
        </div>
      </Col>
      <Col md={5}>
        <DeviceOperations />
      </Col>
    </Row>
  );
};

export default Log;
